<template>
<div v-if="dataLoaded">
    <table-page
        :client="client"
        @updated="getData"
        :warnings="warnings"
        :changelogs="changelogs"
    >
        <fast-table
            :recordLabel="recordLabel"
            :sections="sections"
            :headers="headers"
            :data="tableData"
            :activeRowId="currentRowId"
            @click="currentRowId = $event.id"
        >
            <template v-slot:table-actions>
                <button class="btn btn-primary btn-collapse mr-1" @click="addModalOpen = true">
                    <i class="far fa-fw fa-plus"></i> <span class="btn-text">Add Plan</span>
                </button>
                <button class="btn btn-outline-primary btn-collapse" @click="customModalOpen = true">
                    <i class="far fa-fw fa-plus"></i> <span class="btn-text">Create Custom Plan</span>
                </button>
            </template>
        </fast-table>

        <add-modal
            v-if="addModalOpen"
            :client="client"
            :client-plans="clientPlans"
            :global-plans="globalPlans"
            @updated="onAdded"
            @close="addModalOpen = false"
        />

        <plan-modal
            v-if="customModalOpen"
            :client="client"
            @updated="onAdded"
            @close="customModalOpen = false"
        />
    </table-page>

    <sidebar
        v-if="currentRow"
        :client="client"
        :client-plan="currentRow"
        @updated="getData"
        @close="currentRowId = null"
    />
</div>
</template>

<script>
import TablePageMixin from '@/mixins/TablePageMixin'
import FastTable from '@/components/FastTable'
import PlanModal from '@/pages/admin/accruals/components/PlanModal'
import Sidebar from './components/AccrualPlans/Sidebar'
import AddModal from './components/AccrualPlans/AddModal'

export default {
    components: {FastTable, PlanModal, Sidebar, AddModal, },
    mixins: [TablePageMixin],
    props: ['client'],
    computed: {
        currentRow() {
            return this.clientPlans.find(x => x.id == this.currentRowId)
        },
        sections() {
            return [
                {title: 'Active', defaultIsClosed: false, id: 'active', hasDateFilter: false},
                {title: 'Discontinued', defaultIsClosed: true, id: 'inactive', hasDateFilter: false},
            ]
        },
        tableData() {
            const sections = [
                this.clientPlans.filter(obj => obj.is_active),
                this.clientPlans.filter(obj => !obj.is_active),
            ]

            return sections.map(section => section.map(obj => ({
                id: obj.id,
                object: obj,
                cells: [
                    obj.accrual_plan.name,
                    obj.accrual_plan.plan_type_pretty,
                    obj.accrual_plan.method_pretty,
                    obj.accrual_plan.client_id ? 'Custom' : (obj.accrual_plan.state_pretty || 'All States'),
                    this.availabilityLabel(obj),
                    obj.enrolled_count,
                ],
            })))
        },
    },
    data() {
        return {
            clientPlans: [],
            globalPlans: [],
            dataLoaded: false,
            currentRowId: null,
            recordLabel: 'Plan',
            headers: [
                {label: 'Plan', classes: '', isSearchable: true, defaultSort: true},
                {label: 'Type', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Method', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Plan Source', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Availability', classes: '', isSearchable: false, isFilterable: false},
                {label: 'Enrolled', classes: '', isSearchable: false, isFilterable: false},
            ],
            addModalOpen: false,
            customModalOpen: false,
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Settings / Accruals')
        this.getData()
    },
    methods: {
        availabilityLabel(clientPlan) {
            if (clientPlan.all_positions) {
                return 'All companies'
            }
            const count = clientPlan.positions.length
            return `${count} ${count == 1 ? 'position' : 'positions'}`
        },
        onAdded(clientPlan) {
            this.getData()
            if (clientPlan) {
                this.currentRowId = clientPlan.id
            }
        },
        getData() {
            this.$store.dispatch('START_LOADING')
            Promise.all([
                this.$api.get(`/clients/${this.client.id}/settings/accrual-plans`),
                this.$api.get(`/admin/accruals/plans`),
            ]).then(([clientPlans, globalPlans]) => {
                this.clientPlans = clientPlans
                this.globalPlans = globalPlans
                this.dataLoaded = true
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                if (errors.__status__ == 403) {
                    this.$bus.$emit('no-access')
                }
                else {
                    this.$bus.showError(errors.__all__)
                }
            })
        },
    },
}
</script>
